import { HTMLAttributes } from 'react';
import { PerkCard } from '../components/perk-card';
import { IPerk } from '../types';
import { Skeleton } from 'antd';

export const PerksList: React.FC<
	HTMLAttributes<HTMLDivElement> & { perksDataLoading: boolean; perksData?: IPerk[] | null }
> = ({ perksDataLoading = false, perksData }) => {
	return (
		<Skeleton loading={perksDataLoading}>
			{perksData?.map(perk => (
				<PerkCard
					className="mb-2"
					id={perk._id}
					key={perk._id}
					logo={perk.logo}
					description={perk.description}
					providerName={perk.providerName}
					title={perk.title}
					percent={perk.percent}
					ctaLink={perk.ctaLink}
					promoCode={perk.promoCode}
					requestStatus={perk.requestStatus}
					tags={perk.tags}
				/>
			))}
		</Skeleton>
	);
};
